<template>
  <el-dialog title="窜货产品统计明细" :visible="true" width="85%" :before-close="handleClose">
    <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
      <el-form-item label="记录时间:" style="text-align: center">
        <el-col :span="11">
          <el-date-picker type="date" placeholder="开始时间" v-model="form.start_time" style="width: 100%;" clearable></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker type="date" placeholder="结束时间" v-model="form.end_time" style="width: 100%;" clearable></el-date-picker>
        </el-col>
      </el-form-item>
      <!-- <el-form-item label="窜货经销商:">
                 <el-col :span="12">
                     <el-input v-model="form.code2" clearable readonly></el-input>
                 </el-col>
                 <el-col :span="4" style="margin-left: 10px;">
                     <el-button type="primary" @click="selectDealer1()">选择</el-button>
                 </el-col>
             </el-form-item>-->
      <el-form-item label="被窜货经销商:">
        <el-col :span="12">
          <el-input v-model="form.feeling_sn" clearable readonly></el-input>
        </el-col>
        <el-col :span="4" style="margin-left: 10px;">
          <el-button type="primary" @click="selectDealer2()">选择</el-button>
        </el-col>
      </el-form-item>
      <el-form-item label="来源:" prop="region">
        <el-select v-model="form.source_type" placeholder="请选择来源">
          <el-option label="全部" value=""></el-option>
          <el-option label="扫码" value="1"></el-option>
          <el-option label="退货" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注:">
        <el-input v-model="form.remarks" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getData()">搜索</el-button>
        <el-button type="primary" @click="exportData()">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="multipleTable" v-loading="loading" :data="tableData" height="350" border stripe style="width: 100%;margin: 20px 0">
      <el-table-column prop="code_name" label="标签类型" width="120" fixed>
      </el-table-column>
      <el-table-column prop="logistics_code" label="物流码" width="120" show-overflow-tooltip>
      </el-table-column>

      <el-table-column prop="real_return_goods_num" label="窜货数量" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="from_sn" label="窜货经销商编号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="from_name" label="窜货经销商名称" width="220" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.from_level_name == '未知'">{{scope.row.from_name}}</span>
          <span v-else>({{scope.row.from_level_name}}){{scope.row.from_name}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="from_address" label="窜货地点" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="feeling_sn" label="被窜货经销商编号" width="220" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="feeling_name" label="被窜货经销商名称" width="220" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.feeling_level_name == '未知'">{{scope.row.feeling_name}}</span>
          <span v-else>({{scope.row.feeling_level_name}}){{scope.row.feeling_name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="from_region" label="销售区域" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="created_at" label="记录时间" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="source_type" label="来源" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.source_type == 0">未知</span>
          <span v-if="scope.row.source_type == 1">扫码</span>
          <span v-if="scope.row.source_type == 2">退货</span>
        </template>
      </el-table-column>
      <el-table-column prop="remarks" label="备注" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="pName" label="操作" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="detail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination style="margin: 20px 0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize">
    </el-pagination>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleClose">确 定</el-button>
    </span>
    <!--被窜货/窜货经销商-->
    <selectDealer v-if="selectDealerDialog" v-on:handleClose='selectDealerDialog = false' @pushData="getInfo">
    </selectDealer>
    <!--明细-->
    <dealerDetail v-if="dealerDetailDialog" v-on:handleClose='dealerDetailDialog = false' :detailData="detailData">
    </dealerDetail>

  </el-dialog>
</template>

<script>
import selectDealer from "../../common/selectDealer";
import dealerDetail from "./dealerDetail";

export default {
  name: "productCountDetail",
  data() {
    return {
      selectDealerDialog: false,
      dealerDetailDialog: false,
      form: {
        start_time: "",
        end_time: "",
        source_type: "",
        feeling_sn: "",
        remarksz: "",
      },
      tableData: [],
      //分页
      pageNo: 1, //页码
      pageSize: 20, //每页现实的条数
      totalSize: 0, //总条数
      detailData: "",
      loading: true,
    };
  },
  props: {
    productData: {
      type: Object,
      default: function () {
        return;
      },
    },
  },
  methods: {
    getLastMonth() {
      var now = new Date();
      var year = now.getFullYear() - 1; //getYear()+1900=getFullYear()
      var month = now.getMonth() + 1; //0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year+1 + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //上月总天数
      if (preSize < parseInt(day)) {
        //上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = parseInt(year) - 1 + "-" + month + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last =
          parseInt(year) - 1 + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last =
          parseInt(year) - 1 + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    //获取被我窜经销商的信息
    getInfo(val) {
      this.form.feeling_sn = val.dealer_sn;
    },
    getData() {
      let beginstr = "",
        endstr = "";
      if (this.form.start_time) {
        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
      }
      if (this.form.end_time) {
        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
      }
      let url = "/feelinggoods/products/datas";
      this.loading = true;
      this.$get("logistics", url, {
        lang: "",
        product_sn: this.productData.product_sn,
        per_page: this.pageSize,
        page: this.pageNo,
        start_time: beginstr,
        end_time: endstr,
        source_type: this.form.source_type,
        feeling_sn: this.form.feeling_sn,
        remarks: this.form.remarks,
      })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data;
          this.totalSize = res.meta.total;
        })
        .catch(function (error) {
          this.loading = false;
          console.log(error);
        });
    },
    //导出列表
    exportData() {
      let beginstr = "",
        endstr = "";
      if (this.form.start_time) {
        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
      }
      if (this.form.end_time) {
        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
      }
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");

      window.open(
        this.$Base_Export +
          "/feelinggoods/products/datas.export?is_export=1&start_time=" +
          beginstr +
          "&end_time=" +
          endstr +
          "&product_sn=" +
          this.productData.product_sn +
          "&source_type=" +
          this.form.source_type +
          "&feeling_sn=" +
          this.form.feeling_sn +
          "&remarks=" +
          this.form.remarks +
          "&lang=" +
          "" +
          "&signature=" +
          this.$md5(access_tokens)
      );
    },
    selectDealer1() {
      this.selectDealerDialog = true;
    },
    selectDealer2() {
      this.selectDealerDialog = true;
    },
    detail(row) {
      this.detailData = row.logistics_code;
      this.dealerDetailDialog = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getData();
    },
    handleClose() {
      this.$emit("handleClose");
    },
  },
  created() {
    this.form.start_time = this.getLastMonth().last;
    this.form.end_time = this.getLastMonth().now;
    this.getData();
  },
  components: {
    selectDealer,
    dealerDetail,
  },
};
</script>

<style scoped>
</style>